import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    Stack,
    Alert,
} from '@mui/material';
import RequestService from '../../services/RequestService';

const GroupDeleteDialog = ({ open, onClose, group, onSuccess }) => {
    const handleSubmit = async () => {
        try {
            await RequestService.deleteGroup(group.id);
            onSuccess();
            onClose();
        } catch (err) {
            console.error('Failed to delete group:', err);
        }
    };

    if (!group) {
        return null;
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ padding: '32px 32px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 24,
                            fontWeight: '500',
                            color: '#0C3466',
                            mb: 3,
                        }}
                    >
                        Excluir grupo
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 16,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 2,
                        }}
                    >
                        Essa ação é irreversível e todo o progresso do jogador
                        será perdido.
                    </Typography>
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: 14,
                            fontWeight: '400',
                            color: '#0C3466',
                            mb: 1,
                        }}
                    >
                        Informações do Grupo
                    </Typography>
                    <Box
                        sx={{
                            padding: '24px 10px',
                            backgroundColor: '#EDF8FF',
                            borderRadius: '8px',
                        }}
                    >
                        <Stack direction="column" spacing={1}>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '500',
                                    color: '#292929',
                                }}
                            >
                                Nome: {group.name}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#666666',
                                }}
                            >
                                Jogo: {group.gameName || 'Não informado'}
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins',
                                    fontSize: 14,
                                    fontWeight: '400',
                                    color: '#292929',
                                }}
                            >
                                Jogadores: {group.users?.length || 0}
                            </Typography>
                        </Stack>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="error"
                    variant="contained"
                >
                    Excluir grupo
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroupDeleteDialog;
